import { Document, Page, View, Image, Text, StyleSheet } from '@react-pdf/renderer';
import { DataTableReport, ETYPE_PAGE_REPORT } from 'interfaces/report';
import Table from './component/Table';

export interface ItemPagePdf {
  title?: string;
  chartImages?: string[];
  type: ETYPE_PAGE_REPORT;
  dataTable?: DataTableReport | undefined;
  widthChart?: number;
  countryName?: string;
  startYear?: number;
  endYear?: number;
  baseYear?: number;
}

export interface PDFDocumentProps {
  items: ItemPagePdf[];
}
const percentageMapWidth = {
  1: "550",
  2: "220",
  3: "220",
  4: "220",
  5: "220",
};
const percentageMapHeight = {
  1: "300",
  2: "150",
  3: "150",
  4: "150",
  5: "150",
};
const dataInfoPage1: { left: string; right: string }[] = [
  {
    left: 'Prepared by:',
    right: 'Global Demographics Ltd',
  },
  {
    left: 'Published:',
    right: '',
  },
  {
    left: 'Contact: ',
    right: 'admin@globaldemographics.com',
  },
  {
    left: '',
    right: 'Ph - HK: +852 8121 2907',
  },
  {
    left: '',
    right: 'Ph - HK: +852 8121 2907',
  },
  {
    left: '',
    right: 'Tai Yau Building',
  },
  {
    left: '',
    right: '181 Johnston Road',
  },
  {
    left: '',
    right: 'Wanchai',
  },
  {
    left: '',
    right: 'Hong Kong',
  },
  {
    left: 'Copyright',
    right: 'Global Demographics Ltd',
  },
];
const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 12, paddingTop: 60, paddingLeft: 50},
  item: { marginBottom: 20 },
  title: { fontSize: 13, fontWeight: 'bold', marginBottom: 10, color: 'red' },
  content: { marginBottom: 20, fontSize: 12 },
  image: { width: 200, height: 150, marginBottom: 10 },
  row: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: 10, // nếu dùng react-pdf 3.x, không phải 2.x
    marginBottom: 10,
  },
  countryPage1: {
    fontSize: 18,
    textAlign: 'center',
    color: 'red',
    fontWeight: 'bold',
    marginBottom: 20,
  },

  disclaimerPage1: {
    fontSize: 10,
    marginTop: 40,
    textAlign: 'justify',
  },
});

const PDFDocument: React.FC<PDFDocumentProps> = ({ items }) => {
  const renderTables = (table: DataTableReport): JSX.Element => {
    const totalColumns = table.tableHeaders.length;
    const defaultColumnWidth = 550 / totalColumns;
    const columnWidths = Array(totalColumns).fill(defaultColumnWidth);

    return <Table tableHeaders={table.tableHeaders} dataTables={table.dataTables} columnWidths={columnWidths}></Table>;
  };
  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };
  return (
    <Document>
      {items.length > 0 ? (
        items.map((item, index) => {
          if (item.type === ETYPE_PAGE_REPORT.COVER_PAGE) {
            return (
              <Page size="A4" style={styles.page}>
                <View style={{ width: '550', textAlign: 'center' }}>
                  <Text style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 10 }}>
                    Demographic Forecast from {item.startYear} to {item.baseYear} Actual and as Forecast to {item.endYear}
                  </Text>
                </View>
                <Text style={styles.countryPage1}>{item.countryName}</Text>
                <View style={{ width: '550', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  {dataInfoPage1?.map((it, key) => (
                    <View style={{ width: '260', flexDirection: 'row', justifyContent: 'flex-start', paddingBottom: 8 }}>
                      <View style={{ width: '110', textAlign: 'left', fontSize: 10 }}>
                        <Text>{it.left}</Text>
                      </View>
                      <View style={{ width: '160', textAlign: 'right', fontSize: 10 }}>
                        <Text>{it.right}</Text>
                      </View>
                    </View>
                  ))}
                </View>
                <Text style={{ fontSize: 10, paddingTop: 8, textAlign: 'justify' }}>
                  Global Demographics Ltd makes no warranties, expressed or implied, as to results to be obtained by any person or entity from the use of
                  the information provided and makes no warranties of fitness for a particular purpose or use. In no event shall Global Demographics Ltd or
                  its Affiliates be liable to any user or third parties for direct, indirect, incidental, special or consequential damages, however
                  arising, including without limitation in the event such damages were due to the negligence of Global Demographics Ltd or whether such
                  damages were foreseen or unforseen.
                </Text>
              </Page>
            );
          } else if (item.type === ETYPE_PAGE_REPORT.INTRODUCE_PAGE) {
            return (
              <Page size="A4" style={styles.page}>
                <Text style={{ fontSize: 13, fontWeight: 'bold', marginBottom: 10 }}>Introduction</Text>
                <Text style={{ fontSize: 10, marginBottom: 10, textAlign: 'justify' }}>
                  The first section looks at what will not change in the short-term to 2026 - that is key demographic variables The impact of the economic
                  shock on demographics is minor to negligible on the short term In the medium terms the changes may impact migration rates (lack of
                  employment opportunities for migrants as a result of economic slowdown) and birth rates.
                </Text>
                <Text style={{ fontSize: 10, marginBottom: 10, textAlign: 'justify' }}>
                  They do however, provide context for the subsequent section which looks at how a economic slowdown (or acceleration) impacts employment,
                  productivity and total GDP, and then through changes in employment (changes in workers per household) and Productivity (impact on wages)
                  impact on household incomes and expenditure
                </Text>
              </Page>
            );
          } else {
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.item}>
                  <Text style={styles.title}>{item.title}</Text>
                  {renderTables(item?.dataTable)}
                  {chunkArray(item.chartImages, 2).map((group, rowIndex) => (
                    <View key={rowIndex} style={styles.row}>
                      {group.map((img, i) => (
                         <Image key={i} src={img} style={{width: percentageMapWidth[item.chartImages.length], height: percentageMapHeight[item.chartImages.length]}} />
                      ))}
                    </View>
                  ))}
                </View>
              </Page>
            );
          }
        })
      ) : (
        <Page size="A4" style={styles.page}>
          <Text>Không có dữ liệu để hiển thị</Text>
        </Page>
      )}
    </Document>
  );
};

export default PDFDocument;
